import { Button } from '@trellis/roots/button'
import { Popover, PopoverContent, PopoverTrigger } from '@trellis/roots/popover'
import { Typography } from '@trellis/roots/typography'
import { Bell } from 'lucide-react'
import { useState } from 'react'

import {
  useDismissAllMutation,
  useMarkAllReadMutation,
  useUnreadCountQuery,
} from '@/hooks/useNotifications'

import { NotificationList } from './NotificationList'

export function NotificationBell() {
  const [open, setOpen] = useState(false)
  const { data: unreadResult } = useUnreadCountQuery()
  const markAllRead = useMarkAllReadMutation()
  const dismissAll = useDismissAllMutation()

  const unreadCount = unreadResult?.data?.count ?? 0

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative"
          aria-label={
            unreadCount > 0 ? `Notifications, ${unreadCount} unread` : 'Notifications'
          }
        >
          <Bell className="size-4" aria-hidden="true" />
          {unreadCount > 0 && (
            <span
              aria-hidden="true"
              className="absolute top-1.5 right-1.5 size-2 rounded-full bg-red-500"
            />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[380px] p-0">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <Typography variant="h5" as="h3">
            Notifications
          </Typography>
          {unreadCount > 0 && (
            <div className="flex gap-1">
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground h-auto px-2 py-1 text-xs"
                onClick={() => markAllRead.mutate()}
              >
                Mark all read
              </Button>
              <Button
                variant="ghost"
                size="sm"
                className="text-muted-foreground h-auto px-2 py-1 text-xs"
                onClick={() => dismissAll.mutate()}
              >
                Dismiss all
              </Button>
            </div>
          )}
        </div>
        <NotificationList onNavigate={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}
